import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import TaskListItem from "./TaskListItem";

export default function TaskList() {
  const [tasks, setTasks] = useState([]);
  const inputEl = useRef(null);

  useEffect(() => {
    setTasks(onLoadTasks());
  }, []);

  function onSaveTasks(newTasks = tasks) {
    const data = JSON.stringify(newTasks);
    localStorage.setItem("tasks", data);
  }

  function onLoadTasks() {
    const data = localStorage.getItem("tasks");
    if (data) {
      return JSON.parse(localStorage.getItem("tasks"));
    } else {
      return [];
    }
  }

  function onAddTask() {
    const title = inputEl.current.value;

    if (title.length === 0) {
      return;
    }

    const newTask = {
      title: title,
      isCompleted: false,
    };

    setTasks((prevState) => {
      const newTasks = [newTask, ...prevState];

      inputEl.current.value = "";
      onSaveTasks(newTasks);

      return newTasks;
    });
  }

  function onChangeTaskStatus(index) {
    const newTasks = tasks;
    const task = newTasks[index];

    if (task.isCompleted) {
      task.isCompleted = false;
    } else {
      task.isCompleted = true;
    }

    setTasks(() => [...newTasks]);
    onSaveTasks();
  }

  function onUpdateTaskTitle(index, title) {
    const newTasks = tasks;
    const task = newTasks[index];

    task.title = title;

    setTasks(() => [...newTasks]);
    onSaveTasks();
  }

  function onRemoveTask(index) {
    const newTasks = tasks;

    newTasks.splice(index, 1);

    setTasks(() => [...newTasks]);
    onSaveTasks();
  }

  return (
    <StyledTaskList>
      <div className="inner">
        <div className="task-list-add">
          <input type="text" placeholder="タスクのタイトル" ref={inputEl} />
          <button className="button -primary" onClick={() => onAddTask()}>
            タスクを作成
          </button>
        </div>
        <div className="task-list-wrap -todo">
          <h2>未完了</h2>
          {tasks.length > 0 ? (
            tasks.map(
              (task, i) =>
                !task.isCompleted && (
                  <TaskListItem
                    key={i}
                    index={i}
                    task={task}
                    onChangeTaskStatus={onChangeTaskStatus}
                    onUpdateTaskTitle={onUpdateTaskTitle}
                    onRemoveTask={onRemoveTask}
                  />
                )
            )
          ) : (
            <p>タスクは登録されていません</p>
          )}
        </div>
        <div className="task-list-wrap -completed">
          <h2>完了済み</h2>
          {tasks.length > 0 ? (
            tasks.map(
              (task, i) =>
                task.isCompleted && (
                  <TaskListItem
                    key={i}
                    index={i}
                    task={task}
                    onChangeTaskStatus={onChangeTaskStatus}
                    onUpdateTaskTitle={onUpdateTaskTitle}
                    onRemoveTask={onRemoveTask}
                  />
                )
            )
          ) : (
            <p>タスクは登録されていません</p>
          )}
        </div>
      </div>
    </StyledTaskList>
  );
}

const StyledTaskList = styled.div`
  margin-bottom: 80px;
  .task-list-add {
    display: flex;
    align-items: center;
    padding: 60px 0;
    @media screen and (max-width: 767px) {
      flex-direction: column;
    }
    button {
      margin-left: 8px;
      @media screen and (max-width: 767px) {
        margin-left: 0;
        margin-top: 8px;
      }
    }
  }
  .task-list-wrap {
    & + .task-list-wrap {
      margin-top: 60px;
    }
    h2 {
      margin: 0 0 24px;
    }
  }
`;
